import { render, staticRenderFns } from "./XmSelect.vue?vue&type=template&id=1b9ab8c4&scoped=true"
import script from "./XmSelect.vue?vue&type=script&lang=js"
export * from "./XmSelect.vue?vue&type=script&lang=js"
import style0 from "./XmSelect.vue?vue&type=style&index=0&id=1b9ab8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ab8c4",
  null
  
)

export default component.exports